import styled from "styled-components";

export default styled.div`
  max-height: ${(props) => (props.open ? "10000vh" : "0")};
  overflow: ${(props) => (props.open ? "visible" : "hidden")};
  padding: ${(props) => (props.open ? "0 0 20px 0" : "0")};
  transition: padding 500ms ease;
  background-color: transparent;

  font-family: Merriweather, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;

  color: #000000;
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Accordion/AccordionContent.js